import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trocarSenha } from '../../store/modules/LoginActions';
import { closeModal, openModal } from '../../store/modules/ModalActions';
import {
  changeProfessorEditingValue,
  clearProfessorEditing,
  loadProfessorByCPF,
  saveAutoCadastro,
  saveProfessorByCPF,
} from '../../store/modules/ProfessoresActions';
import { getInputFocusInFocusOutAttr } from '../../utils/HTMLUtils';
import { getUnmaskedValue } from '../../utils/InputMaskUtils';
import {
  allIsTrue,
  cpfIsValid,
  equalIsValid,
  maskedValueRequiredIsValid,
  passwordIsValid,
  requiredIsValid,
} from '../../utils/ValidationUtils';
import { CustomTextField } from '../CustomTextField';
import { GenericModal } from '../GenericModal';
import RefreshIcon from '../Icons/RefreshIcon';
import SaveIcon from '../Icons/SaveIcon';
import { CPFMaskedInput } from '../MaskedInputs';
import { Col } from './../Col';
import { CustomButton } from './../CustomButton';
import { Row } from './../Row';
import styles from './PrimeiroAcessoModal.scss';
import { isAuthenticated } from '../../services/Auth/AuthService';
import SnackbarUtils from 'utils/SnackbarUtils';

const rootClassName = styles.rootClassName;

const INITIAL_STATE = {
  open: false,
  saving: false,
  disableBackdropClick: true,
  disableEscapeKeyDown: true,

  cpf: '',
  senhaAntiga: '',
  novaSenha: '',
  repeatNovaSenha: '',

  cpfChanged: false,
  senhaAntigaChanged: false,
  novaSenhaChanged: false,
  repeatNovaSenhaChanged: false,

  focusedFieldName: null,
};

class PrimeiroAcessoModal extends Component {
  validations = {
    cpfIsValid: { status: true },
    senhaAntigaIsValid: { status: true },
    novaSenhaIsValid: { status: true },
    repeatNovaSenhaIsValid: { status: true },
  };

  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE,
    };

    this.setValue = this.setValue.bind(this);
    this.focusIn = this.focusIn.bind(this);
    this.focusOut = this.focusOut.bind(this);
  }

  UNSAFE_componentWillMount() {
    if (typeof this.props.cpf === 'string' && this.props.cpf.length > 0) {
      this.setState({
        ...this.state,
        cpf: this.props.cpf,
      });
    }
  }

  changeState(newState) {
    this.setState({
      ...this.state,
      ...newState,
    });
  }

  fieldDisabled() {
    return this.state.saving === true ? true : false;
  }

  reset() {
    this.setState(INITIAL_STATE);
  }

  componentWillUnmount() {
    this.reset();
  }

  getTitle() {
    return isAuthenticated()
      ? this.props.languageValues.primeiroAcessoModalTitle
      : this.props.languageValues.changePasswordModalTitle;
  }

  setValue(event) {
    this.setState({
      ...this.state,
      [event.target.name]: event.target.value,
      [event.target.name + 'Changed']: true,
    });
  }

  cpfValueIsValid() {
    if (this.state.focusedFieldName === 'cpf') {
      const value = this.state.cpf;
      const required = maskedValueRequiredIsValid(
        value,
        this.props.languageValues.validations.cpf.required
      );
      const validation = cpfIsValid(
        value,
        this.props.languageValues.validations.cpf.validation
      );
      if (!required.status) {
        this.validations.cpfIsValid = required;
        return this.validations.cpfIsValid;
      }
      if (!validation.status) {
        this.validations.cpfIsValid = validation;
        return this.validations.cpfIsValid;
      }
      this.validations.cpfIsValid = {
        status: true,
      };
      return this.validations.cpfIsValid;
    } else {
      return this.validations.cpfIsValid;
    }
  }

  senhaAntigaValueIsValid() {
    if (this.state.focusedFieldName === 'senhaAntiga') {
      const value = this.state.senhaAntiga;
      const required = requiredIsValid(
        value,
        this.props.languageValues.validations.oldPassword.required
      );
      if (!required.status) {
        this.validations.senhaAntigaIsValid = required;
        return this.validations.senhaAntigaIsValid;
      }
      this.validations.senhaAntigaIsValid = {
        status: true,
      };
      return this.validations.senhaAntigaIsValid;
    } else {
      return this.validations.senhaAntigaIsValid;
    }
  }

  novaSenhaValueIsValid() {
    const value = this.state.novaSenha;
    const required = requiredIsValid(
      value,
      this.props.languageValues.validations.newPassword.required
    );
    const validation = passwordIsValid(
      value,
      this.props.languageValues.validations.newPassword.validation
    );
    if (!required.status) {
      this.validations.novaSenhaIsValid = required;
      return this.validations.novaSenhaIsValid;
    }
    if (!validation.status) {
      this.validations.novaSenhaIsValid = validation;
      return this.validations.novaSenhaIsValid;
    }
    this.validations.novaSenhaIsValid = {
      status: true,
    };
    return this.validations.novaSenhaIsValid;
  }

  repeatNovaSenhaValueIsValid() {
    const value = this.state.repeatNovaSenha;
    const required = requiredIsValid(
      value,
      this.props.languageValues.validations.repeatNewPassword.required
    );
    const validation = equalIsValid(
      value,
      this.state.novaSenha,
      this.props.languageValues.validations.repeatNewPassword.validation
    );
    if (!required.status) {
      this.validations.repeatNovaSenhaIsValid = required;
      return this.validations.repeatNovaSenhaIsValid;
    }
    if (!validation.status) {
      this.validations.repeatNovaSenhaIsValid = validation;
      return this.validations.repeatNovaSenhaIsValid;
    }
    this.validations.repeatNovaSenhaIsValid = {
      status: true,
    };
    return this.validations.repeatNovaSenhaIsValid;
  }

  formIsValid() {
    return allIsTrue([
      this.cpfValueIsValid().status,
      this.senhaAntigaValueIsValid().status,
      this.novaSenhaValueIsValid().status,
      this.repeatNovaSenhaValueIsValid().status,
    ]);
  }

  toSubmit() {
    if (!this.formIsValid()) {
      return false;
    }

    this.changeState({
      saving: true,
    });
    this.props.trocarSenha(
      {
        cpf: getUnmaskedValue(this.state.cpf),
        senhaAntiga: this.state.senhaAntiga,
        novaSenha: this.state.novaSenha,
      },
      () => {
        SnackbarUtils.enqueueSnackbar({
          message: this.props.languageValues.successSalvarPrimeiroAcesso,
          options: {
            variant: 'success',
          },
        });
        this.changeState({
          saving: false,
          disableBackdropClick: false,
          disableEscapeKeyDown: false,
        });
        window.localStorage.clear();
        this.toClose();
        if (typeof this.props.savedCallback === 'function') {
          this.props.savedCallback();
        }
      },
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText ||
            this.props.languageValues.erroSalvarPrimeiroAcesso,
          options: {
            variant: 'error',
          },
        });
        this.changeState({
          saving: false,
          disableBackdropClick: false,
          disableEscapeKeyDown: false,
        });
      }
    );
  }

  toCancel = () => {
    window.localStorage.clear();
    if (typeof this.props.cancelCallback === 'function') {
      this.props.cancelCallback();
    }
    this.toClose();
  };

  toClose() {
    this.props.closeModal(this.props.modalKey);
  }

  focusIn(fieldName) {
    this.setState({
      ...this.state,
      focusedFieldName: fieldName,
    });
  }

  focusOut(fieldName) {
    if (this.state.focusedFieldName === fieldName) {
      this.setState({
        ...this.state,
        focusedFieldName: null,
      });
    }
  }

  render() {
    return (
      <GenericModal
        onClose={() => {
          this.toCancel();
        }}
        DialogProps={{
          maxWidth: 'xs',
          PaperProps: {
            className: rootClassName + '-dialog-paper-modal',
          },
          open: this.props.opened,
          disableBackdropClick: this.state.disableBackdropClick,
          disableEscapeKeyDown: this.state.disableEscapeKeyDown,
        }}
        title={
          <>
            {this.getTitle()}
            {this.state.saving ? (
              <RefreshIcon className={rootClassName + '-loading-icon'} />
            ) : null}
          </>
        }
        footerContent={
          <Row>
            <Col cols={[12, 12, 12, 12, 12]}>
              <CustomButton
                theme='pufvYellow'
                className={rootClassName + '-cancel-button'}
                label={this.props.languageValues.cancelButton}
                onClick={() => this.toCancel()}
              />
              <CustomButton
                theme='pufvYellow'
                className={rootClassName + '-save-buttom'}
                label={this.props.languageValues.salvar}
                disabled={this.state.saving || !this.formIsValid()}
                rightIcon={<SaveIcon />}
                type='submit'
              />
            </Col>
          </Row>
        }
        onSubmit={(event) => {
          event.preventDefault();
          this.toSubmit();
        }}
      >
        <Row>
          <Col cols={[12, 12, 12, 12, 12]}>
            <p className={rootClassName + '-text-intro'}>
              {isAuthenticated()
                ? this.props.languageValues.primeiroAcessoTextIntro
                : this.props.languageValues.changePasswordTextIntro}
            </p>
          </Col>
        </Row>
        <Row>
          <Col cols={[12, 12, 12, 12, 12]}>
            <CustomTextField
              label={this.props.languageValues.primeiroAcessoCPFLabel}
              name='cpf'
              value={this.state.cpf}
              onChange={(event) => {
                this.setValue(event);
              }}
              helperText={
                this.state.cpfChanged && !this.cpfValueIsValid().status
                  ? this.cpfValueIsValid().error
                  : ''
              }
              error={this.state.cpfChanged && !this.cpfValueIsValid().status}
              disabled={this.fieldDisabled()}
              InputProps={{
                inputComponent: CPFMaskedInput,
              }}
              {...getInputFocusInFocusOutAttr(this.focusIn, this.focusOut)}
            />
          </Col>
        </Row>
        <Row>
          <Col cols={[12, 12, 12, 12, 12]}>
            <CustomTextField
              label={this.props.languageValues.primeiroAcessoSenhaAntigaLabel}
              name='senhaAntiga'
              value={this.state.senhaAntiga}
              onChange={(event) => {
                this.setValue(event);
              }}
              maxSize={200}
              type='password'
              helperText={
                this.state.senhaAntigaChanged &&
                  !this.senhaAntigaValueIsValid().status
                  ? this.senhaAntigaValueIsValid().error
                  : ''
              }
              error={
                this.state.senhaAntigaChanged &&
                !this.senhaAntigaValueIsValid().status
              }
              disabled={this.fieldDisabled()}
              {...getInputFocusInFocusOutAttr(this.focusIn, this.focusOut)}
            />
          </Col>
        </Row>
        <Row>
          <Col cols={[12, 12, 12, 12, 12]}>
            <CustomTextField
              label={this.props.languageValues.primeiroAcessoNovaSenhaLabel}
              name='novaSenha'
              value={this.state.novaSenha}
              onChange={(event) => {
                this.setValue(event);
              }}
              maxSize={200}
              type='password'
              helperText={
                this.state.novaSenhaChanged &&
                  !this.novaSenhaValueIsValid().status
                  ? this.novaSenhaValueIsValid().error
                  : ''
              }
              error={
                this.state.novaSenhaChanged &&
                !this.novaSenhaValueIsValid().status
              }
              disabled={this.fieldDisabled()}
              {...getInputFocusInFocusOutAttr(this.focusIn, this.focusOut)}
            />
          </Col>
        </Row>
        <Row>
          <Col cols={[12, 12, 12, 12, 12]}>
            <CustomTextField
              label={
                this.props.languageValues.primeiroAcessoRepeatNovaSenhaLabel
              }
              name='repeatNovaSenha'
              value={this.state.repeatNovaSenha}
              onChange={(event) => {
                this.setValue(event);
              }}
              maxSize={200}
              type='password'
              helperText={
                this.state.repeatNovaSenhaChanged &&
                  !this.repeatNovaSenhaValueIsValid().status
                  ? this.repeatNovaSenhaValueIsValid().error
                  : ''
              }
              error={
                this.state.repeatNovaSenhaChanged &&
                !this.repeatNovaSenhaValueIsValid().status
              }
              disabled={this.fieldDisabled()}
              {...getInputFocusInFocusOutAttr(this.focusIn, this.focusOut)}
            />
          </Col>
        </Row>
      </GenericModal>
    );
  }
}

PrimeiroAcessoModal.propTypes = {
  cpf: PropTypes.string,
  opened: PropTypes.bool,
  modalKey: PropTypes.string.isRequired,
  cancelCallback: PropTypes.func,
  savedCallback: PropTypes.func,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  professores: state.professores,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeProfessorEditingValue,
      loadProfessorByCPF,
      clearProfessorEditing,
      saveProfessorByCPF,
      saveAutoCadastro,
      closeModal,
      openModal,
      trocarSenha,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrimeiroAcessoModal);
